import { createEntityAdapter } from '@ngrx/entity';
import { SocieteTerritoirePatrimoineEntityState } from '@get/api-interfaces';
import { CustomEntityState } from '@get/store/configs/states';

export type IState = CustomEntityState<SocieteTerritoirePatrimoineEntityState>;

export const adapter = createEntityAdapter<SocieteTerritoirePatrimoineEntityState>({
  selectId: o => o.idSocieteTerritoirePatrimoine
});
export const initialState: IState = adapter.getInitialState({
  isLoaded: false,
  isLoading: false,
  actives: []
});

export const societeTerritoirePatrimoineFeatureKey = 'societeTerritoirePatrimoine';
